export default "__VITE_ASSET__Bu300Ija__"